import React from "react";

import { useFormikContext } from "formik";

import ErrorBadgeButton from "manager/components/DealSetupSettings/DealSetupForm/ErrorBadgeButton";
import { Button } from "shared/components/Button";
import FlexContainer from "shared/components/FlexContainer";
import Icon from "shared/components/Icon";
import { ActionLink } from "shared/components/Links";
import { useConfigLock } from "shared/hooks/useConfigLock";

interface PropertySettingsFooterProps {
  isPortfolioSettings: boolean;
  openCustomizeSettingsModal: () => void;
  openResetSettingsModal: () => void;
  isActionLoading?: boolean;
}

const PropertySettingsFooter = ({
  isPortfolioSettings,
  openCustomizeSettingsModal,
  openResetSettingsModal,
  isActionLoading = false,
}: PropertySettingsFooterProps) => {
  const { dirty, isSubmitting } = useFormikContext();
  const { isLocked } = useConfigLock();

  if (isLocked) {
    return null;
  }

  return isPortfolioSettings ? (
    /* @ts-ignore */
    <Button
      type="primary"
      htmlType="button"
      onClick={openCustomizeSettingsModal}
      loading={isActionLoading}
      disabled={isActionLoading}
    >
      Update Settings
    </Button>
  ) : (
    <FlexContainer nodesMargin="0 0 0 36px" alignItems="center">
      <ActionLink
        onClick={isActionLoading ? undefined : openResetSettingsModal}
        style={{
          pointerEvents: isActionLoading ? "none" : "auto",
          opacity: isActionLoading ? 0.6 : 1,
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        {isActionLoading && (
          <Icon.LoadingSpinnerIcon
            style={{ width: 14, height: 14, marginTop: -1 }}
          />
        )}
        {isActionLoading ? "Resetting..." : "Reset to portfolio settings"}
      </ActionLink>
      <ErrorBadgeButton
        isSubmitting={isSubmitting}
        dirty={dirty}
        disabled={isActionLoading}
      />
    </FlexContainer>
  );
};

export default PropertySettingsFooter;
